
import { assign } from '../common/utils';

const initialState = {
    acList: [],
    mobileNum: '',
    show_loading: false,
    promoInfo: [],
    seatsGroup: [],
    partition: false
};

const seat = (state = initialState, action) => {
    switch (action.type) {
        case 'acList':
            return assign(state, {
                acList: action.acList
            });
        case 'mobileNum':
            return assign(state, {
                mobileNum: action.mobileNum
            });
        case 'show_loading':
            return assign(state, {
                show_loading: action.show_loading
            });
        case 'show_lockErrorPop':
            return assign(state,{
                show_lockErrorPop:action.show_lockErrorPop
            })
        case 'promoInfo':
            return assign(state, {
                promoInfo: action.promoInfo
            });
        case 'seatsGroup':
            return assign(state, {
                seatsGroup: action.seatsGroup
            });
        case 'partition':
            return assign(state, {
                partition: action.partition
            });
        default:
            return state;
    };
};

export default seat;
